'use client'

import { Locale } from '@/locales'
import { ReactNode, createContext, useContext } from 'react'

export type Dictionary = Record<string, string>

interface I18nBootstrapValue {
  lang: Locale
  dictionary: Dictionary
  complete: boolean
}

const I18nBootstrapContext = createContext<I18nBootstrapValue | null>(null)

interface I18nBootstrapProviderProps {
  value: I18nBootstrapValue
  children: ReactNode
}

export function I18nBootstrapProvider({
  value,
  children,
}: I18nBootstrapProviderProps) {
  return (
    <I18nBootstrapContext.Provider value={value}>
      {children}
    </I18nBootstrapContext.Provider>
  )
}

export function useI18nBootstrap() {
  return useContext(I18nBootstrapContext)
}
